import React from 'react';
import { AppHeader } from './AppHeader';

interface GradientHeaderProps {
  organizationName: string;
  organizationLogoUrl?: string;
  subtitle?: string;
  user: any;
  isDark: boolean;
  isAdmin: boolean;
  roleLoading?: boolean;
  displayName: string;
  showBackButton?: boolean;
  showBetaBadge?: boolean;
  onToggleTheme: () => void;
  onSignIn: () => void;
  onNavigateHome: () => void;
  onNavigateAdmin?: () => void;
  onOpenProfile?: () => void;
}

export function GradientHeader(props: GradientHeaderProps) {
  return (
    <header className="flex-shrink-0 bg-gradient-to-b from-theme-primary to-theme-secondary shadow-lg">
      <AppHeader {...props} />
    </header>
  );
}
